<template>
  <div class="home">
    
    <div class="calendar-grid">
      <div class="header">
        <h1 class="title"><span class="filled">My Life in</span> Perspective</h1>
        <span>Better experience in desktop</span>
      </div>
      <div class="root-grid">
        <div class="time-selector">
          <datepicker placeholder="Select your birthdate" v-model="birthdate" :bootstrap-styling="true" input-class="date-picker" :open-date="openDate">
            <div slot="beforeCalendarHeader" class="calender-header">
              Choose your birthdate
            </div>
          </datepicker>
          <span class="time-title">This is <strong> 90 years</strong>, each square represents a </span> 
          <select v-model="selectedTime">
            <option value="weeks">week</option>
            <option value="months">month</option>
            <option value="years">year</option>
          </select>
        </div>
        <CalendarGrid :selectedTime="selectedTime" :birthdate="birthdate"/>
      </div>
    </div>
    <Articles v-bind:birthdate="birthdate" v-bind:lifeExpectancyInYears="lifeExpectancyInYears"/>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
// @ is an alias to /src
import CalendarGrid from '../components/CalendarGrid';
import Articles from '../components/Articles';
export default {
  name: 'Home',
  data() {
    return {
      birthdate: null,
      selectedTime: 'weeks',
      lifeExpectancyInYears: 73.2,
    }
  },
  components: {
    CalendarGrid,
    Articles,
    Datepicker
  },
  computed: {
    openDate: function(){
      return new Date("01/01/1990");
    }
  }
}
</script>
<style>
  
.input-group .form-control{
  text-align: center !important;
}
.vdp-datepicker input, .vdp-datepicker select {
  padding: 0.75em 0.5em;
  font-size: 100%;
  border: 1px solid #ccc;
  width: 100%;
}
.vdp-datepicker{
  text-align: center !important;
}

.vdp-datepicker select {
  height: 2.5em;
}

.date-picker{
  /* height: 100px; */
  background: #f8f8f8;
  border: 1px solid #ddd;
  border-radius: 5px;
  padding: 0em 1em 1em;
  margin-bottom: 2em;  
}
.time-title{
  font-weight: medium;
  font-size: x-large;
}
.time-selector{
  max-width: 80%;
  text-align: center;
  padding-bottom: 10px;
}
.time-selector select{
  cursor: pointer;
  font-family: 'Lobster', cursive;
  border: none;
  background-color: #f9f9f9;
  color: #ff746b;
  font-size: x-large;
  display: inline-block;
}
.time-selector select::selection, .time-selector select:focus{
  outline: none;
  border: none;
}

.time-selector{
  position: relative;
  display: inline;
}



</style>
